(() => {
	angular.module('main').service('workflowService', workflowService);

	workflowService.$inject = [
		'$rootScope',
		'messageService',
		'workflowDataService',
		'workflowDragNDropService',
		'randomStringGenerator',
		'validationService',
		'timeService',
		'settingsService',
		'newWorkflowService'
	];

	function workflowService(
		$rootScope,
		messageService,
		workflowDataService,
		workflowDragNDropService,
		randomStringGenerator,
		validationService,
		timeService,
		settingsService,
		newWorkflowService
	) {
		let taskInfo = {};

		const dateItems = ['days', 'months', 'hours'];

		let taskDateSequence = [
			'after lead created',
			'after job accepted',
			'before main shoot',
			'after main shoot',
			'after previous task'
		];

		const automatedActions = [
			{
				shortName: 'SEND_EMAIL',
				fullName: 'This task sends an email'
			},
			{
				shortName: 'SEND_QUESTIONNAIRE',
				fullName: 'This task sends a questionnaire'
			},
			{
				shortName: 'SEND_CONTRACT',
				fullName: 'This task sends a contract'
			}
		];

		const modalIds = {
			appointment: '#appointment',
			appointmentWithoutSchedule: '#appointmentWithoutScheduleModal',
			automation: '#addAutomationModal',
			extraShoot: '#extraShootModal',
			extraShootWithoutSchedule: '#extraShootWithoutScheduleModal',
			todo: '#addTodoModal'
		};

		const taskTypeNames = {
			lead: 'LEAD',
			production: 'PRODUCTION',
			postProduction: 'POST_PRODUCTION'
		};

		const eventTypes = {
			appointment: 'APPOINTMENT',
			extraShoot: 'EXTRA_SHOOT',
			mainShoot: 'MAIN_SHOOT'
		};

		function getTaskDates() {
			return dateItems;
		}

		function getTaskDateSequence() {
			return taskDateSequence;
		}

		function setTaskDateSequence(newTaskDateSequence) {
			taskDateSequence = JSON.parse(JSON.stringify(newTaskDateSequence));
		}

		function getAutomatedActions() {
			return automatedActions;
		}

		function setTaskInfo(task = {}, taskList = [], isForEdit = false) {
			if (!task.due) {
				task = addDefaultDue(task);
			} else {
				task.hasDue = true;
			}
			taskInfo = { task, taskList, isForEdit };
		}

		function addEmptyTask() {
			return {
				id: null,
				defaultTask: false,
				hasDue: false,
				hasMail: false,
				name: ''
			};
		}

		function addDefaultDue(task) {
			const taskCopy = angular.copy(task);
			if (!taskCopy.id) {
				taskCopy.id = null;
			}
			taskCopy.due = 1;
			taskCopy.dateItem = dateItems[0];
			taskCopy.dateSequence = taskDateSequence[0].id;
			return taskCopy;
		}

		function getTaskInfo() {
			const isTaskInfoEmpty = angular.equals(taskInfo, {});
			if (isTaskInfoEmpty) {
				taskInfo.task = addEmptyTask();
			}
			return taskInfo;
		}

		function isEmailTemplateChosen(email, fromSettings) {
			const isEmail =
				email !== null &&
				typeof email !== 'undefined' &&
				typeof email === 'object';
			if (!isEmail) {
				return false;
			}
			if (!fromSettings || isEmail) {
				return true;
			}
			const invalidEmail =
				email.hasOwnProperty('text') &&
				!email.hasOwnProperty('subject') &&
				!email.hasOwnProperty('name');
			return !invalidEmail;
		}

		function isEmailFieldsValid(email, fromSettings) {
			if (typeof email === 'undefined' || email === null) {
				return false;
			}
			const { name, subject } = email;

			if (fromSettings && validationService.isStringEmpty(name)) {
				messageService.showToaster('e_9', 'emailTemplate', 'name');
				return false;
			}

			if (subject !== null && validationService.isStringEmpty(subject)) {
				fromSettings
					? messageService.showToaster('e_9', 'emailTemplate', 'subject')
					: messageService.showToaster('e_5', 'workflow');
				return false;
			}

			return true;
		}

		function isTaskValid(task, fromSettings = false) {
			const isAutomation = task.hasMail || task.action;

			if (validationService.isStringEmpty(task.name)) {
				messageService.showToaster('e_1', 'workflow');
				return false;
			}

			if (task.hasDue || task.due) {
				const isDueDaysFilled = task.due || task.due >= 1;
				if (!isDueDaysFilled) {
					messageService.showToaster('e_2', 'workflow');
					return false;
				}
			}

			if (isAutomation) {
				if (!task.action) {
					messageService.showToaster('e_3', 'workflow');
					return false;
				}

				if (!isEmailTemplateChosen(task.taskEmail, fromSettings)) {
					messageService.showToaster('e_4', 'workflow');
					return false;
				}

				if (!isEmailFieldsValid(task.taskEmail, fromSettings)) {
					return false;
				}
			}

			return true;
		}

		function checkTaskDue(task) {
			const taskCopy = angular.copy(task);

			if (!taskCopy.hasDue || !taskCopy.due) {
				delete taskCopy.due;
				delete taskCopy.dateItem;
				taskCopy.dateSequence = null;
			}

			return taskCopy;
		}

		function replaceTask(oldTask, newTask, taskTypes) {
			const isTaskId = oldTask.id !== null && oldTask.id !== undefined;
			const identificator = isTaskId ? 'id' : 'number';

			const siblingTasks = getSiblingTasks(oldTask, taskTypes);
			siblingTasks.some((item, index) => {
				if (oldTask[identificator] === item[identificator]) {
					siblingTasks[index] = newTask;
					return true;
				}
			});
			return taskTypes;
		}

		function getMainShootIndex(tasksArr) {
			for (let i = 0, max = tasksArr.length; i <= max; i++) {
				const event = tasksArr[i].hasOwnProperty('eventType')
					? 'eventType'
					: 'calendarEventType';
				if (tasksArr[i][event] === eventTypes.mainShoot) {
					return i;
				}
			}
		}

		function getTaskIndex(task, tasksArr) {
			for (let i = 0, max = tasksArr.length; i <= max; i++) {
				if (tasksArr[i].number === task.number) {
					return i;
				}
			}
		}

		function concatTasksArr(taskTypes) {
			let tasks = [];
			taskTypes.forEach(taskType => {
				tasks = tasks.concat(...taskType);
			});

			return tasks;
		}

		function filterTasksWithDueDate(tasks) {
			return tasks.filter(task => task.dueDate || task.startDate);
		}

		function addTaskDateTime(tasks) {
			return tasks.map(task => {
				const date = task.dueDate || task.startDate;
				let time = task.dueTime || task.startTime;
				if (task.type === taskTypeNames.lead && task.number === 0) {
					time = null;
				}
				task.dateTime = timeService.getDateAndTime(date, time);
				return task;
			});
		}

		function orderTasksByDate(tasks) {
			return tasks.sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime));
		}

		function getNextTaskByDate(task, taskTypes) {
			let foundTask;

			const tasks = concatTasksArr(taskTypes);
			const tasksWithDueDate = filterTasksWithDueDate(tasks);
			const tasksWithDateTime = addTaskDateTime(tasksWithDueDate);
			const orderedTasksByDate = orderTasksByDate(tasksWithDateTime);

			const taskDateTime = timeService.getDateAndTime(
				task.startDate,
				task.startTime
			);

			const nextTask = orderedTasksByDate.find(
				taskInList => taskDateTime < taskInList.dateTime
			);

			if (nextTask) {
				foundTask = nextTask;
			} else {
				const lastTaskWithDate =
					orderedTasksByDate[orderedTasksByDate.length - 1];
				foundTask = getTaskAfterLastWithDate(taskTypes, lastTaskWithDate);
			}

			return foundTask || tasks[tasks.length - 1];
		}

		function getTaskAfterLastWithDate(taskTypes, lastTaskWithDate) {
			return getTaskByNumber(lastTaskWithDate.number + 1, taskTypes);
		}

		function pasteNewTaskInList(taskTypes, task2Paste) {
			let taskTypesCopy = angular.copy(taskTypes);

			const task = checkTaskDue(task2Paste);

			let taskInList = false;

			if (task.number !== null && task.number !== undefined) {
				if (task.id !== null && task.id !== undefined) {
					taskInList = workflowDragNDropService.getTaskById(
						task2Paste,
						taskTypes
					);
				} else {
					taskInList = getTaskByNumber(task2Paste.number, taskTypes);
				}
			}

			if (taskInList) {
				let currentDateSequence = task.dateSequence;
				if (!currentDateSequence || !task.hasDue || !task.due) {
					currentDateSequence = null;
				}
				const isDateSequenceChanged =
					taskInList.dateSequence !== currentDateSequence;
				const isTaskStartDateChanged =
					taskInList.startDate && taskInList.startDate !== task.startDate;
				if (isDateSequenceChanged || isTaskStartDateChanged) {
					deleteTaskFromList(taskInList, taskTypesCopy);
				} else {
					taskTypesCopy = replaceTask(taskInList, task, taskTypesCopy);
					return taskTypesCopy;
				}
			}

			taskTypesCopy = task.startDate
				? pasteTaskWithDate(task, taskTypesCopy)
				: pasteTaskWithoutDate(task, taskTypesCopy);

			return taskTypesCopy;
		}

		function pasteTaskWithoutDate(task, taskTypes) {
			const [lead, production, postProduction] = taskTypes;
			const mainShootIndex = getMainShootIndex(production);

			switch (task.dateSequence) {
				case taskDateSequence[0].id:
					lead.splice(lead.length, 0, task);
					break;
				case taskDateSequence[1].id:
				case taskDateSequence[2].id:
					production.splice(mainShootIndex, 0, task);
					break;
				case taskDateSequence[3].id:
					postProduction.splice(0, 0, task);
					break;
				case taskDateSequence[4].id:
					postProduction.splice(postProduction.length - 1, 0, task);
					break;
				default:
					postProduction.splice(postProduction.length - 1, 0, task);
					break;
			}

			taskTypes = [lead, production, postProduction];
			taskTypes = workflowDragNDropService.renewTaskList(taskTypes);

			return taskTypes;
		}

		function pasteTaskWithDate(task, taskTypes) {
			let taskToPasteType, nextTaskIndex;
			const [lead, production, postProduction] = taskTypes;
			const MIN_INDEX = 1;

			const nextTask = getNextTaskByDate(task, taskTypes);
			taskToPasteType = nextTask.type;

			switch (taskToPasteType) {
				case taskTypeNames.lead:
					nextTaskIndex = getTaskIndex(nextTask, lead);

					// not to paste on first position
					if (nextTaskIndex === 0) {
						nextTaskIndex = MIN_INDEX;
					}

					lead.splice(nextTaskIndex, 0, task);
					break;

				case taskTypeNames.production:
					nextTaskIndex = getTaskIndex(nextTask, production);

					// not to paste on first position
					if (nextTaskIndex === 0) {
						nextTaskIndex = MIN_INDEX;
					}

					production.splice(nextTaskIndex, 0, task);
					break;

				case taskTypeNames.postProduction:
				default:
					nextTaskIndex = getTaskIndex(nextTask, postProduction);
					// prefer pasting calendar events in production stage
					if (nextTaskIndex === 0) {
						production.push(task);
						break;
					}
					postProduction.splice(nextTaskIndex, 0, task);
					break;
			}

			taskTypes = [lead, production, postProduction];
			taskTypes = workflowDragNDropService.renewTaskList(taskTypes);

			return taskTypes;
		}

		function getSiblingTasks(task, taskTypes) {
			const [leadCreated, jobAccepted, jobCompleted] = taskTypes;
			switch (task.type) {
				case taskTypeNames.lead:
					return leadCreated;
				case taskTypeNames.production:
					return jobAccepted;
				case taskTypeNames.postProduction:
					return jobCompleted;
				default:
					break;
			}
		}

		function deleteTaskFromList(task, taskTypes) {
			const siblingTasks = getSiblingTasks(task, taskTypes);

			const isTaskId = task.id !== null && task.id !== undefined;
			const identificator = isTaskId ? 'id' : 'number';

			siblingTasks.some((item, index) => {
				if (task[identificator] === item[identificator]) {
					siblingTasks.splice(index, 1);
					return true;
				}
			});
		}

		function getTaskTemplates(id, successCallback) {
			return workflowDataService
				.getTaskTemplates(id)
				.subscribe(
					data => successCallback(data),
					error => messageService.showDefaultErrorMessage(error)
				);
		}

		function saveWorkflowTemplate(workflow, successCallback) {
			return workflowDataService
				.saveWorkflow(workflow)
				.map(
					data => successCallback(data, workflow),
					result => errorSaveTask(result)
				);
		}

		function getJobWorkflow(id, successCallback) {
			return workflowDataService
				.getWorkflow(id)
				.subscribe(
					data => successCallback(data),
					error => messageService.showDefaultErrorMessage(error)
				);
		}

		function deleteTask(taskTypes, task) {
			return workflowDataService.deleteTask(task.id);
		}

		function validateEmailLinks(action, emailTemplateId) {
			return workflowDataService.validateEmailLinks(action, emailTemplateId);
		}

		function validateEmailName(email) {
			if (email.id) {
				return Rx.Observable.of('');
			}
			return workflowDataService.validateEmailName(email);
		}

		function deleteTaskFromSettings(workflow, taskTypes, task) {
			const workflowCopy = angular.copy(workflow);

			if (task.id !== null && task.id !== undefined) {
				if (!workflowCopy.taskToDelete) {
					workflowCopy.taskToDelete = [];
				}
				workflowCopy.taskToDelete.push(task.id);
			}

			deleteTaskFromList(task, taskTypes);

			return workflowCopy;
		}

		function getTaskByNumber(number, taskTypes) {
			for (let i = 0, max = taskTypes.length; i < max; i++) {
				const taskType = taskTypes[i];
				const foundTask = taskType.find(item => number === item.number);
				if (foundTask) {
					return foundTask;
				}
			}
			return null;
		}

		const filterTasksBy = (taskList, tasksType) =>
			taskList.filter(task => task.type === tasksType);

		function calcTaskOverdue(overdueDays) {
			let taskOverdue;

			if (overdueDays > 0) {
				taskOverdue = isNaN(overdueDays)
					? NaN
					: `! ${overdueDays} day${overdueDays > 1 ? 's' : ''} overdue`;
			}

			return taskOverdue || overdueDays || null;
		}

		function pluralizeDue(dueAmount, dueItem) {
			let resultDue;
			const isPluralItem = dueItem.endsWith('s');

			if (dueAmount > 1) {
				resultDue = isPluralItem ? dueItem : `${dueItem}s`;
			} else {
				resultDue = isPluralItem ? dueItem.slice(0, -1) : dueItem;
			}

			return resultDue;
		}

		const getTaskViewDue = (task, taskTypes) => {
			let taskViewDue = null;
			const {
				dateItem,
				due,
				dateSequence,
				previousTask: prevTaskNumber
			} = task;
			const isTaskDue = [
				dateItem,
				due != 'undefined',
				due != null,
				dateSequence
			].every(Boolean);
			if (!isTaskDue) {
				return taskViewDue;
			}

			const dateItemTmp = pluralizeDue(due, dateItem.toLowerCase());

			const dateSequenceTmp = dateSequence.replace('_', ' ').toLowerCase();

			taskViewDue = `${due} ${dateItemTmp} `;

			if (dateSequence === 'after previous task') {
				const previousTask = getTaskByNumber(prevTaskNumber, taskTypes);
				taskViewDue +=
					previousTask !== null
						? `after ${previousTask.name}`
						: dateSequenceTmp;
			} else {
				taskViewDue += dateSequenceTmp;
			}
			return taskViewDue;
		};

		function renewTaskViewDue(taskList) {
			const renewedList = angular.copy(taskList);
			renewedList.forEach(taskType => {
				taskType.forEach(task => {
					task.taskViewDue = getTaskViewDue(task, renewedList);
				});
			});
			return renewedList;
		}

		function fillWorkflowTasks(taskList = []) {
			return [
				filterTasksBy(taskList, 'LEAD'),
				filterTasksBy(taskList, 'PRODUCTION'),
				filterTasksBy(taskList, 'POST_PRODUCTION')
			];
		}

		function prepareTaskToSave(task, jobId) {
			const task2save = angular.copy(task);

			const { overdueDays, taskEmail: email } = task2save;

			if (overdueDays) {
				task2save.overdueDays = parseInt(overdueDays.match(/\d+/)[0], 10);
			}

			if (email) {
				email.text = $rootScope.addMaiStyling(email.text);
			}

			if (task2save.jobId === null || task2save.jobId === undefined) {
				task2save.jobId = jobId;
			}

			if (task2save.tmpId) {
				delete task2save.tmpId;
			}

			return task2save;
		}

		function errorSaveTask(result) {
			const { data, error } = result;

			if (error && error.errorCode) {
				toastr.clear();
				messageService.handleError(result);
				return;
			}

			if (result.errorMessage) {
				toastr.clear();
				messageService.showErrorFromBackend(
					'Whoops, something has gone wrong!',
					result.errorMessage
				);
			}

			if (data.errorMessage === 'Signed contract cannot be modified') {
				messageService.showErrorFromBackend(
					'Whoops, something has gone wrong!',
					data.errorMessage
				);
			} else if (data.errorMessage) {
				let errorCode, errorPlace;

				switch (data.errorMessage) {
					case "Tasks can't have due < 1 (if present)":
						errorCode = 'e_2';
						errorPlace = 'workflow';
						break;
					case 'Email text should contain a questionnaire link':
						errorCode = 'e_6';
						errorPlace = 'emailTemplate';
						break;
					case 'Email text should contain a contract link':
						errorCode = 'e_5';
						errorPlace = 'emailTemplate';
						break;
					case 'Please, reload the file':
						errorCode = 'e_7';
						errorPlace = 'workflow';
						break;
					default:
						errorCode = 'e_0';
						errorPlace = 'general';
				}
				toastr.clear();
				messageService.showToaster(errorCode, errorPlace);
			} else {
				toastr.clear();
				messageService.showToaster('e_0', 'general');
			}
		}

		function saveTask(task, jobId, taskTypes) {
			let task2Save = angular.copy(task);

			const isTaskId = task2Save.id !== null && task2Save.id !== undefined;

			if (!isTaskId) {
				task2Save.tmpId = randomStringGenerator.getMixedString();
			}

			let taskTypesCopy = angular.copy(taskTypes);

			if (!isTaskValid(task2Save)) {
				return Rx.Observable.throwError('Not a valid task');
			}

			task2Save = checkTaskDue(task2Save);
			taskTypesCopy = pasteNewTaskInList(taskTypesCopy, task2Save);
			taskTypesCopy = workflowDragNDropService.renewTaskList(taskTypesCopy);

			const newTaskPosition = workflowDragNDropService.getTaskById(
				task2Save,
				taskTypesCopy
			);

			task2Save.number = newTaskPosition.number;
			// if ((task2Save.calendarEventType !== "APPOINTMENT" || task2Save.calendarEventType !== "EXTRA_SHOOT") && task2Save.type !== "LEAD") {
			task2Save.type = newTaskPosition.type;
			// } else {
			//     task2Save.type = "LEAD";
			// }
			task2Save = prepareTaskToSave(task2Save, jobId);

			return workflowDataService.saveTask(task2Save);
		}

		function chooseModalToShow(task, template) {
			let modal = '';

			const eventType = task.eventType || task.calendarEventType;

			if (task.action || task.hasMail) {
				modal = modalIds.automation;
			} else if (eventType === eventTypes.appointment && template) {
				modal = modalIds.appointmentWithoutSchedule;
			} else if (eventType === eventTypes.appointment && !template) {
				modal = modalIds.appointment;
			} else if (eventType === eventTypes.extraShoot && template) {
				modal = modalIds.extraShootWithoutSchedule;
			} else if (eventType === eventTypes.extraShoot && !template) {
				modal = modalIds.extraShoot;
			} else {
				modal = modalIds.todo;
			}

			return modal;
		}

		function setLabelsToTaskDateSequence() {
			settingsService.customizeLabelsObservable
				.filter(labels => labels.mainShootLabel)
				.subscribe(labels => {
					setTaskDateSequence(setCorrectNaming(labels.mainShootLabel));
					newWorkflowService.setTaskDateSequence(
						newWorkflowService.setCorrectNaming(labels.mainShootLabel)
					);
				});

			function setCorrectNaming(mainShootLabel) {
				const originalTaskDateSequence = [
					'after lead created',
					'after job accepted',
					'before main shoot',
					'after main shoot',
					'after previous task'
				];

				return originalTaskDateSequence.map(taskName => ({
					id: taskName,
					name: taskName.includes('main shoot')
						? taskName.replace('main shoot', mainShootLabel.toLowerCase())
						: taskName
				}));
			}
		}

		return {
			addEmptyTask,
			calcTaskOverdue,
			chooseModalToShow,
			deleteTask,
			deleteTaskFromSettings,
			getAutomatedActions,
			getTaskTemplates,
			getTaskByNumber,
			getTaskInfo,
			getTaskDates,
			getTaskDateSequence,
			// isLabelShown,
			getTaskViewDue,
			getJobWorkflow,
			errorSaveTask,
			filterTasksBy,
			fillWorkflowTasks,
			isTaskValid,
			validateEmailLinks,
			validateEmailName,
			pasteNewTaskInList,
			renewTaskViewDue,
			saveTask,
			setTaskInfo,
			saveWorkflowTemplate,
			setLabelsToTaskDateSequence
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/workflowService.js